<template>
    <layout>
        <div>
            <!-- FORM HEADER -->
            <div>
                <!-- Breadcrumbs -->
                <!-- Cart Summary -->
            </div>
            <!-- DROPSHIP -->
            <div>
                <span>Drop Ship This Order?</span>
                <input
                    id="dropship_yes"
                    type="radio"
                    name="drop_ship_yes"
                    :value="true"
                    v-model="form.shipping_dropship"
                />
                <label for="dropship_yes">Yes</label>
                <input
                    id="dropship_no"
                    type="radio"
                    name="drop_ship"
                    :value="false"
                    v-model="form.shipping_dropship"
                />
                <label for="dropship_no">No</label>
                <span
                    >We'll send items directly to your customer from our
                    warehouse for a small additional fee per order</span
                >
            </div>
            <!-- SHIPPING ADDRESS -->
            <div>
                <AddressInput v-model="addressInput" />
            </div>
            <!-- SHIPPING OPTIONS -->
            <div></div>
            <!-- SHIP BLIND -->
            <div></div>
            <!-- SHIPPING METHOD -->
            <div></div>
            <!-- SAVE TO DEFAULTS -->
            <div></div>
            <!-- BUTTON: Continue to Billing & Payment -->
        </div>
    </layout>
</template>
<script setup lang="ts">
    import { ref, computed } from "vue";
    import Layout from "@/Shared/Layout.vue";
    import AddressInput from "@/components/AddressInput.vue";

    interface ShippingForm {
        shipping_dropship: boolean;
    }
    interface ShippingAddress {}

    const form = ref<ShippingForm>({
        shipping_dropship: false
    });

    let addressInput = ref<ShippingAddress>({});
</script>
